var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"headline"},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Виберіть опцію в меню ліворуч ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }